// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"962b8cbd","173":"e9f6eb87","209":"ada13d52","228":"9981e831","437":"e40b6e2c","453":"55b9a33e","478":"871409d5","482":"e3bab59e","794":"c3b704ac","915":"bad0c2b4"}[chunkId] + ".chunk.js";
};